module.exports = __webpack_public_path__ + "img/2025-0429-01-02.d1429899.png";